export const MIDGARD_TESTNET_URL = 'https://testnet.midgard.thorchain.info'
export const MIDGARD_CHAOSNET_URL = 'https://midgard.thorchain.info'

export const THORNODE_TESTNET_URL = 'https://testnet.thornode.thorchain.info'
export const THORNODE_MAINNET_URL = 'https://thornode.thorchain.info'
